import { State, BP_Status } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';

const getBpmnXmlParsingStatus = (state: State): BP_Status => state.bpmnXmlParsingStatus;

export const selectGetBpmnXmlParsingStatus: MemoizedSelector<
  object,
  BP_Status
  > = createSelector(selectBpmnProcessState, getBpmnXmlParsingStatus);
